export class CheckErrorMsg {
    constructor(element) {
        this.element = element;
        if (element.shadowRoot) {
            this.child = element.shadowRoot.firstElementChild;
            this.errorMsg = element.shadowRoot.querySelector('ep-form-msg').shadowRoot.querySelector('.error-msg');
            return;
        }
        this.child = element.firstElementChild;
        this.errorMsg = element.querySelector('ep-form-msg').shadowRoot.querySelector('.error-msg');
    }
    checkErrorMsg(validator) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (validator.isValid()) {
            (_a = this.errorMsg) === null || _a === void 0 ? void 0 : _a.removeAttribute('not-valid');
            (_c = (_b = this.errorMsg) === null || _b === void 0 ? void 0 : _b.style) === null || _c === void 0 ? void 0 : _c.removeProperty('display');
            (_d = this.element) === null || _d === void 0 ? void 0 : _d.removeAttribute('not-valid');
            (_e = this.child) === null || _e === void 0 ? void 0 : _e.removeAttribute('not-valid');
            return;
        }
        (_f = this.errorMsg) === null || _f === void 0 ? void 0 : _f.setAttribute('not-valid', '');
        (_g = this.errorMsg) === null || _g === void 0 ? void 0 : _g.style.setProperty('display', 'block');
        (_h = this.element) === null || _h === void 0 ? void 0 : _h.setAttribute('not-valid', '');
        (_j = this.child) === null || _j === void 0 ? void 0 : _j.setAttribute('not-valid', '');
        const container = document.createElement('span');
        const list = document.createElement('ep-list');
        container.append(list);
        validator.getErrorMessages().forEach((msg) => {
            const li = document.createElement('li');
            li.append(msg);
            list.append(li);
        });
        if (list.childElementCount > 1) {
            list.setAttribute('ordered', 'true');
        }
        if (list.childElementCount <= 1) {
            list.removeAttribute('ordered');
        }
        this.errorMsg.shadowRoot.innerHTML = container.innerHTML;
    }
}
//# sourceMappingURL=checkErrorMsg.js.map